import { useState } from 'react';
import { currency } from 'functions';

const OrderBump = ({
  products,
  selectedBumps,
  setSelectedBumps,
  updateQuantity,
}) => {
  const selectBump = (item, assignment) => {
    let prevSelectedBumps = [...selectedBumps];
    if (!item.show_quantity) {
      const isItemInArray = prevSelectedBumps.find(
        (bump) => bump.uuid === item.uuid
      );
      if (isItemInArray) {
        setSelectedBumps(
          selectedBumps.filter((value) => {
            return value.uuid !== item.uuid;
          })
        );
      } else {
        setSelectedBumps([...prevSelectedBumps, item]);
      }
    }
    if (item.show_quantity) {
      if (assignment === '+') {
        setSelectedBumps([...prevSelectedBumps, item]);
      }
      if (assignment === '-') {
        const index = prevSelectedBumps.indexOf(item);
        if (index > -1) {
          setSelectedBumps([...prevSelectedBumps.splice(index, 1)]);
        }
      }
    }
  };

  return (
    <>
      <section id='order-bump'>
        <div className='card-head'>
          {products.length === 1
            ? 'Oferta especial separada '
            : 'Ofertas especiais separadas, '}
          para você!
        </div>
        <div className='bump-list'>
          {products.map((item, index) => {
            return (
              <div className='bump' key={item.uuid}>
                {item.show_quantity ? (
                  <div className='d-flex flex-wrap ob-physical'>
                    <div className='d-flex w-100'>
                      {item.product.cover && <img src={item.product.cover} />}
                      <div className='description'>
                        <div className='text'>
                          <b className='mr-1'>{item.product.name}</b>
                          <span>- {item.label}</span>
                        </div>
                        <div className='price'>
                          {item.price_before && (
                            <span className='before-price'>
                              de <span>{currency(item.price_before)}</span>
                            </span>
                          )}
                          <span className='current-price'>
                            {' '}
                            por <span>{currency(item.price)}</span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='select-product'>
                      <div className='quantity'>
                        <button
                          className='quantity-button'
                          disabled={!item.quantity}
                          onClick={(e) => {
                            e.preventDefault();
                            updateQuantity(index, -1);
                            selectBump(item, '-');
                          }}
                        >
                          -
                        </button>
                        <div className='quantity-number'>{item.quantity}</div>
                        <button
                          className='quantity-button'
                          onClick={(e) => {
                            e.preventDefault();
                            updateQuantity(index, +1);
                            selectBump(item, '+');
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <label htmlFor={`order-bump-${index}`} className='label-info'>
                    <div className='d-flex flex-wrap ob-info'>
                      <div className='d-flex w-100'>
                        {item.product.cover && <img src={item.product.cover} />}
                        <div className='w-100 description'>
                          <div className='text'>
                            <b className='mr-1'>{item.product.name}</b>
                            <span>- {item.label}</span>
                          </div>
                          <div className='price'>
                            {item.price_before && (
                              <span className='before-price'>
                                de <span>{currency(item.price_before)}</span>
                              </span>
                            )}
                            <span className='current-price'>
                              {' '}
                              por <span>{currency(item.price)}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='select-product'>
                      <input
                        id={`order-bump-${index}`}
                        type='checkbox'
                        onChange={() => {
                          updateQuantity(
                            index,
                            selectedBumps.find(
                              (bump) => bump.uuid === item.uuid
                            )
                              ? -1
                              : +1
                          );
                          selectBump(item);
                        }}
                      />
                      <span
                        className={
                          selectedBumps.find((bump) => bump.uuid === item.uuid)
                            ? 'custom-check checked'
                            : 'custom-check'
                        }
                      >
                        <i className='las la-hand-point-right hand' />
                        <i className='las la-check checky' />
                      </span>
                    </div>
                  </label>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default OrderBump;
